import type { FC, ReactNode } from 'react';
import styled from 'styled-components';

import { ButtonBase } from '#src/atoms/buttons/ButtonBase/index.tsx';
import { Vertical } from '#src/atoms/layout/flex/index.tsx';

const StyledButton = styled(ButtonBase)`
  display: flex;
  align-items: center;
  padding: var(--double-unit);
  gap: var(--double-unit);
  text-align: left;
  background: var(--c-nd-100);
  color: var(--c-nd-700);
  &:hover,
  &:focus {
    background: var(--c-nd-200);
    color: var(--c-white);
  }
  > *:first-child:not(:last-child) {
    max-width: 32px;
  }
`;

const Wrapper = styled(Vertical).attrs({ gap: 0 })`
  border: 1px solid var(--c-nd-100);
  border-radius: var(--unit);
  overflow: hidden;

  & > *:not(:last-child) {
    border-bottom: 1px solid var(--c-nd-100);
  }
`;

export type ButtonProps = FC<
  React.PropsWithChildren<{
    onClick?: () => void;
    href?: string;
  }>
>;
const ButtonComponent: ButtonProps = ({ children, href, onClick }) => {
  return (
    <StyledButton
      as={href ? 'a' : 'button'}
      href={href}
      onClick={onClick}
      {...(href ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
    >
      {children}
    </StyledButton>
  );
};

type Props = {
  children: (buttonComponent: ButtonProps) => ReactNode;
};

export const ButtonsList = ({ children }: Props) => {
  return <Wrapper>{children(ButtonComponent)}</Wrapper>;
};
